// extracted by mini-css-extract-plugin
module.exports = {"textWithTooltip":"az"};